import * as fromSeriousSystem from '@serious-system';

/**
 * "Image" is derived from the same icon map that keys off the accepted upload
 * extensions (jpg/jpeg/png → `FileTypeIconsEnum.image`). Keeping this the single
 * predicate for image-ness in the message row ensures the click-routing and the
 * chatbot-reply source filter can never disagree about what counts as an image.
 */
export const isImageDocumentExtension = (extension: string): boolean =>
  fromSeriousSystem.getFileTypeIconFromExtension(extension) ===
  fromSeriousSystem.FileTypeIconsEnum.image;

/**
 * Drops image documents from a list. Used for the chip row UNDER a chatbot
 * reply (`ff-display-document-sources`): an uploaded image is a chat-only
 * visual (SB-3271, KD-6) that belongs in the Sources sidebar and opens via the
 * overlay, but must not appear as an answer "source" beneath the reply — unlike
 * a PDF there is nothing to cite/highlight in it. Defense-in-depth: holds even
 * if core-ai keeps echoing the image in the answer's output documents.
 */
export const excludeImageDocuments = <T extends { extension: string }>(
  documents: readonly T[],
): T[] =>
  documents.filter((document) => !isImageDocumentExtension(document.extension));
